import { type ComponentPropsWithRef, type ReactNode } from 'react'

import { type FloatingBoxType } from '@/defs/floating'
import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import { StyledContent } from '../../StyledContent'

import styles from './FloatingBox.module.scss'

type Props = {
  close?: ReactNode
  overflowVisible?: boolean
} & FloatingBoxType &
  DistributiveOmit<ComponentPropsWithRef<'div'>, keyof FloatingBoxType>

export const FloatingBox = ({
  borderColor,
  close,
  content,
  disablePointerEvents,
  overflowVisible,
  padding,
  size,
  style,
  styled,
  variant = 'box',
  width,
  ...props
}: Props) => {
  const contentElement = styled ? <StyledContent size='sm'>{content}</StyledContent> : content

  return (
    <div
      className={cn(styles.container, {
        borderColor,
        overflowVisible,
        padding,
        size,
        styles,
        variant,
        width,
      })}
      style={disablePointerEvents ? { ...style, pointerEvents: 'none' } : style}
      {...props}
    >
      {close}
      <div className={styles.focusTrap} tabIndex={0} />
      {contentElement}
    </div>
  )
}
